import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
export default {
  name: 'NiotaClassicDevicesAddAddNew',
  mixins: [formMixin],
  props: {
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    datasourceType: {
      type: String,
      required: false,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      adrLimits: [{
        id: '0',
        title: 'SF 12 / BW 125 MHz'
      }, {
        id: '1',
        title: 'SF 11 / BW 125 MHz'
      }, {
        id: '2',
        title: 'SF 10 / BW 125 MHz'
      }, {
        id: '3',
        title: 'SF 9 / BW 125 MHz'
      }, {
        id: '4',
        title: 'SF 8 / BW 125 MHz'
      }, {
        id: '5',
        title: 'SF 7 / BW 125 MHz'
      }, {
        id: '6',
        title: 'SF 7 / BW 250 MHz'
      }],
      connectivityPlans: [],
      deviceProfiles: [],
      qrScanner: false,
      deviceData: {},
      otaa: true,
      addressObject: {
        address: '',
        coordinates: [null, null]
      },
      operationalStatus: [{
        value: 0,
        text: this.$i18n_t('NiotaClassic.Devices.form.unset')
      }, {
        value: 1,
        text: this.$i18n_t('NiotaClassic.Devices.form.inTransit')
      }, {
        value: 2,
        text: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation')
      }, {
        value: 3,
        text: this.$i18n_t('NiotaClassic.Devices.form.inOperation')
      }, {
        value: 4,
        text: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive')
      }, {
        value: 5,
        text: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      }],
      motionIndicators: ['NEAR_STATIC', 'WALKING_SPEED', 'BIKE_SPEED', 'VEHICLE_SPEED', 'RANDOM'],
      actilityOptionsIsLoading: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    isUdp() {
      if (this.datasourceType === 'udp') {
        return true;
      } else {
        return false;
      }
    },
    isFirefly() {
      if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly') {
        return true;
      } else {
        return false;
      }
    },
    isActility() {
      if (this.datasourceType === 'actility') {
        return true;
      } else {
        return false;
      }
    },
    isWebhookOrFilesys() {
      if (this.datasourceType === 'webhook' || this.datasourceType === 'filesystem') {
        return true;
      } else {
        return false;
      }
    },
    buttons() {
      return [{
        icon: 'fal fa-arrow-left',
        action: 'back',
        tooltip: this.$i18n_t('Common.reset')
      }, {
        icon: 'fal fa-barcode-read',
        action: 'qr',
        tooltip: this.$i18n_t('NiotaClassic.Devices.form.qrScanner')
      }, {
        icon: 'fas fa-save',
        tooltip: this.$i18n_t('Common.save'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    coordinateLookup() {
      return get(this.deviceData, 'properties.coordinateMode') !== 'manual';
    }
  },
  watch: {
    datasourceType() {
      this.initData();
    },
    editedItem() {
      this.initData();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.deviceData = cloneDeep(this.editedItem);
      if (!this.deviceData.properties) {
        this.deviceData.properties = {};
        this.deviceData.region = 'EU868';
      }
      if (this.datasourceType === 'actility') {
        this.fetchActilityOptions();
      }
      this.setAddressObject();
    },
    filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    filterConnectivityPlan(item, queryText) {
      return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    fetchActilityOptions() {
      this.actilityOptionsIsLoading = true;
      NiotaClassicApiService.fetchActilityOptions(this.editedItem.originatorId).then(res => {
        let connectivityPlans = get(res, 'data.connectivity_plans');
        let deviceProfiles = get(res, 'data.device_profiles');
        if (isArray(connectivityPlans)) {
          this.connectivityPlans = res.data.connectivity_plans;
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.actilityError'), 'error');
          console.error(connectivityPlans);
        }
        if (isArray(deviceProfiles)) {
          this.deviceProfiles = res.data.device_profiles;
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.actilityError'), 'error');
          console.error(deviceProfiles);
        }
      }).catch(error => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingActilityOptions'), 'error');
        console.error(error);
      }).finally(() => {
        this.actilityOptionsIsLoading = false;
      });
    },
    createDevice() {
      NiotaClassicApiService.deviceCreate(this.deviceData).then(res => {
        if (!res.data.err) {
          this.deviceData = res.data.device;
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.createSuccess'), 'success');
          this.$emit('refreshList');
          this.$emit('close');
        } else {
          this.$snack(res.data.err, 'error');
        }
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.err) {
          this.$snack(error.response.data.err, 'error');
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.createFailed'), 'error');
        }
      });
    },
    randomEui() {
      this.deviceData.eui = this.randomString(16);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomDeviceAddress() {
      this.deviceData.deviceAddress = this.randomString(8);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomApplSessionKey() {
      this.deviceData.applSessionKey = this.randomString(32);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomApplKey() {
      this.deviceData.applKey = this.randomString(32);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomNetwSessionKey() {
      this.deviceData.netwSessionKey = this.randomString(32);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomString(len) {
      let charSet = 'ABCDEF0123456789';
      let randomString = '';
      for (let i = 0; i < len; i++) {
        let randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
      }
      return randomString;
    },
    addNewDevice() {
      this.deviceData = this.newDevice();
      this.createDevice();
    },
    newDevice() {
      this.deviceData.cType = this.datasourceType;
      if (this.deviceData.deviceType && this.deviceData.deviceType.id) {
        this.deviceData.deviceTypeId = this.deviceData.deviceType.id;
        this.deviceData.deviceTypeTitle = this.deviceData.deviceType.title;
      }
      if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly') {
        this.deviceData.cType = 'firefly';
        if (this.deviceData.adr_limit && this.deviceData.adr_limit.id) {
          this.deviceData.adr_limit_name = this.deviceData.adr_limit.title;
          this.deviceData.adr_limit = this.deviceData.adr_limit.id;
        }
        if (this.deviceData.region && this.deviceData.region.id) {
          this.deviceData.region_name = this.deviceData.region.title;
          this.deviceData.region = this.deviceData.region.id;
        }
      } else if (this.datasourceType === 'actility') {
        if (this.deviceData.connectivity_plans && this.deviceData.connectivity_plans.id) {
          this.deviceData.connectivityPlanId = this.deviceData.connectivity_plans.id;
          this.deviceData.connectivityPlanName = this.deviceData.connectivity_plans.name;
          this.deviceData.connectivity_planName = this.deviceData.connectivity_plans.name;
        }
        if (this.deviceData.device_profiles && this.deviceData.device_profiles.id) {
          this.deviceData.deviceProfileId = this.deviceData.device_profiles.id;
          this.deviceData.device_profileName = this.deviceData.device_profiles.name;
        }
      }
      if (this.otaa) {
        this.deviceData.otaa = true;
      } else {
        this.deviceData.otaa = false;
      }
      return this.deviceData;
    },
    setAddressObject() {
      this.addressObject = {
        address: this.deviceData.physicalAddress,
        coordinates: [this.deviceData.lon || null, this.deviceData.lat || null]
      };
    },
    addressSelected(addressData) {
      this.deviceData.physicalAddress = addressData.address;
      [this.deviceData.lon, this.deviceData.lat] = addressData.coordinates;
      this.deviceData.properties = {
        ...(this.deviceData.properties || {}),
        coordinateMode: addressData.pickedManualCoordinates ? 'manual' : 'auto'
      };
      this.setAddressObject();
    },
    tagsChanged(tags) {
      this.deviceData.tags = tags;
    }
  }
};